import * as api from "@/api/tokens";
import { ApiError } from "@/types";
import { AxiosError } from "axios";
import { getConfiguration } from "@/api/configurations";
import { LoginCredentials, PasswordChangeRequest } from "@/api/tokens";
import { requestPasswordReset, resetPassword } from "@/api/resets";
import { ServiceClient } from "@/util";
import { useLogin } from "@/hooks";
import { useMutation, useQueryClient } from "react-query";
import { useNavigate } from "react-router";

export function useChangePassword() {
  return useMutation((request: PasswordChangeRequest) => api.changePassword(request));
}

export function useLoginQuery(withBarcode?: boolean) {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const login = useLogin();

  return useMutation(async (credentials: LoginCredentials) => {
    try {
      const response = await api.login(credentials);
      const token = response.data;
      login.setToken(token, withBarcode);

      const config = await getConfiguration();
      queryClient.setQueryData("configurations", config);

      if (response.status === 202) {
        navigate("/login/reset");
      } else {
        navigate("/");
      }
    } catch (error) {
      if (error instanceof AxiosError) {
        throw new ApiError(error.response?.status);
      }
    }
  });
}

export function useRequestPasswordReset() {
  return useMutation((userId: string) => requestPasswordReset(userId));
}

export function useResetPassword(resetToken?: string) {
  const navigate = useNavigate();

  return useMutation(async (newPassword: string) => {
    try {
      await resetPassword(newPassword, resetToken);

      if (ServiceClient.isAuthenticated()) {
        navigate("/");
      }
    } catch (error) {
      if (error instanceof AxiosError) {
        throw new ApiError(error.response?.status);
      }
    }
  });
}
